<template>
  <div class="page">
    <div class="header-menu">
      <navBar v-model="objSave"></navBar>
    </div>
    <div class="buttom-menu"></div>
    <div class="page-content">
      <div class="editPassword">
        <div class="editPassword-item">
          <label>{{$t('system.OriginalPassword')}}</label>
          <input type="text" :placeholder="$t('placeholders.OriginalPassword')" />
        </div>
        <div class="border_bottom"></div>
        <div class="editPassword-item">
          <label>{{$t('system.NewPassword')}}</label>
          <input type="text" :placeholder="$t('placeholders.NewPassword')" />
        </div>
        <div class="border_bottom"></div>
        <div class="editPassword-item">
          <label>{{$t('system.AffirmNewPassword')}}</label>
          <input type="text" :placeholder="$t('placeholders.AffirmNewPassword')" />
        </div>
        <div class="editPassword-btn">
          <div @click="Save">{{$t('share.Save')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script scoped>
  import navBar from '../../modules/navBar.vue'
  export default {
    name: 'editPassword',
    data() {
      return {

        objSave: {
          centerTitle:'system.ChangePassword',
          rightTitle: {}
        },

      }
    },
    methods: {
      Save() {

      }
    },
    components: {
      navBar
    }
  }

</script>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }
  .editPassword-item {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.266rem;
    height: 1.064rem;
  }

  .editPassword-item label {
    display: inline-block;
    min-width: 2.660rem;
  }

  .editPassword-item input {
    height: 100%;
    width: 100%;
    border: none
  }

  .editPassword-btn {
    margin-top: 1.064rem;
    padding: 0 0.532rem;
  }

  .editPassword-btn>div {
    background-color: #12a3ff;
    height: 0.930rem;
    line-height: 0.930rem;
    text-align: center;
    color: #fff;
    border-radius: 0.106rem;
  }

</style>
